export default __webpack_public_path__ + "static/media/element_58.48fb1c23.webp";